import { NavButton } from '@talos/kyoko';
import styled from 'styled-components';

export const LoginWrapper = styled.div`
  width: ${({ theme }) => theme.baseSize * 24}px;
  background: ${({ theme }) => theme.backgroundContent};
  padding: ${({ theme }) => theme.spacing48}px;
  align-items: center;
  display: flex;
  flex-direction: column;

  p {
    margin: ${({ theme }) => theme.spacing48}px 0 ${({ theme }) => theme.spacing24}px;
    line-height: 1.5;
  }

  ${NavButton} {
    width: 100%;
  }
`;
